// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Consistent page content width inside the inset app surface */

.page-shell {
  width: 100%;
  max-width: var(--layout-page-max);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  min-width: 0;
}

.page-shell--narrow {
  max-width: 720px;
}

.page-shell--wide {
  max-width: 1200px;
}

.page-shell__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  margin-bottom: var(--space-2);
}

.page-shell__title-block {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.page-shell__stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

@media (max-width: 768px) {
  .page-shell {
    gap: var(--space-4);
  }

  .page-shell__stack {
    gap: var(--space-4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PageShell/PageShell.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,WAAW;EACX,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Consistent page content width inside the inset app surface */\n\n.page-shell {\n  width: 100%;\n  max-width: var(--layout-page-max);\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n  min-width: 0;\n}\n\n.page-shell--narrow {\n  max-width: 720px;\n}\n\n.page-shell--wide {\n  max-width: 1200px;\n}\n\n.page-shell__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--space-4);\n  margin-bottom: var(--space-2);\n}\n\n.page-shell__title-block {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  min-width: 0;\n}\n\n.page-shell__stack {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n\n@media (max-width: 768px) {\n  .page-shell {\n    gap: var(--space-4);\n  }\n\n  .page-shell__stack {\n    gap: var(--space-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
